import { render, staticRenderFns } from "./PasswordResetFinishPage.vue?vue&type=template&id=fef211b8&scoped=true&"
import script from "./PasswordResetFinishPage.vue?vue&type=script&lang=js&"
export * from "./PasswordResetFinishPage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetFinishPage.vue?vue&type=style&index=0&id=fef211b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef211b8",
  null
  
)

export default component.exports